/*
 * @Author: 王一宁 wangyining@fenxiangbuy.com
 * @Date: 2024-08-06 14:23:42
 * @LastEditors: 王一宁 wangyining@fenxiangbuy.com
 * @LastEditTime: 2024-08-28 11:26:29
 * @FilePath: /shengsheng-client/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/Register.vue"),
    meta: {
      title: "爱省生活注册",
    },
  },
  {
    path: "/taobaoAuth",
    name: "taobaoAuth",
    component: () => import("../views/TaobaoAuth.vue"),
    meta: {
      title: "淘宝授权",
    },
  },
  {
    path: "/aggrement/privacy",
    name: "Privacy",
    component: () => import("../views/aggrement/privacy.vue"),
    meta: {
      title: "隐私协议",
    },
  },
  {
    path: "/aggrement/mike-privacy",
    name: "MikePrivacy",
    component: () => import("../views/aggrement/mike-privacy.vue"),
    meta: {
      title: "Mike情报隐私协议",
    },
  },
  {
    path: "/aggrement/user",
    name: "User",
    component: () => import("../views/aggrement/user.vue"),
    meta: {
      title: "用户协议",
    },
  },
  {
    path: "/aggrement/behavior",
    name: "Behavior",
    component: () => import("../views/aggrement/behavior.vue"),
    meta: {
      title: "行为规范",
    },
  },
  {
    path: "/cash/read",
    name: "CashRead",
    component: () => import("../views/cash/read.vue"),
    meta: {
      title: "提现须知",
    },
  },
  {
    path: "/user/question",
    name: "Question",
    component: () => import("../views/user/question.vue"),
    meta: {
      title: "常见问题",
    },
  },
  {
    path: "/user/new-read",
    name: "NewRead",
    component: () => import("../views/user/new-read.vue"),
    meta: {
      title: "新手必看",
    },
  },
  {
    path: "/user/share-reward",
    name: "ShareReward",
    component: () => import("../views/user/share-reward.vue"),
    meta: {
      title: "奖励规则",
    },
  },
  {
    path: "/company/company-qualification",
    name: "CompanyQualification",
    component: () => import("../views/company/company-qualification.vue"),
    meta: {
      title: "公司资质",
    },
  },
  {
    path: "/download-guide",
    name: "DownloadGuide",
    component: () => import("../views/DownloadGuide.vue"),
    meta: {
      title: "下载爱省生活",
    },
  },
  {
    path: "/smile-order/",
    name: "SmileOrderIndex",
    redirect: "/smile-order/login",
    meta: {
      title: "报单中心",
    },
    children: [
      {
        path: "/smile-order/login",
        name: "SmileOrderLoginIndex",
        component: () => import("../views/smile-order/login.vue"),
        meta: {
          title: "手机号验证码登录",
        },
      },
      {
        path: "/smile-order/actives",
        name: "SmileOrderActivesIndex",
        component: () => import("../views/smile-order/actives/index.vue"),
        meta: {
          title: "活动列表",
        },
      },
      {
        path: "/smile-order/report",
        name: "SmileOrderReportIndex",
        component: () => import("../views/smile-order/actives/index.vue"),
        meta: {
          title: "报单中心",
        },
      },
      {
        path: "/smile-order/orders",
        name: "SmileOrderOrdersIndex",
        component: () => import("../views/smile-order/orders/index.vue"),
        meta: {
          title: "订单查询",
        },
      },

      {
        path: "/smile-order/profile",
        name: "SmileOrderProfileIndex",
        component: () => import("../views/smile-order/profile/index.vue"),
        meta: {
          title: "个人中心",
        },
      },
    ],
  },
  {
    path: "/mike-order",
    name: "MikeOrder",
    component: () => import("../views/mike-order/index.vue"),
    meta: {
      title: "订单查询",
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "爱省生活";

  // 报单中心路由登录态校验
  if (to.path.startsWith("/smile-order")) {
    // 排除登录页面
    if (to.path === "/smile-order/login") {
      next();
      return;
    }

    // 检查是否有登录态（sessionId）
    const sessionId = localStorage.getItem("smileOrderSessionId");
    if (!sessionId) {
      // 未登录，跳转到登录页面
      next({
        path: "/smile-order/login",
        query: { redirect: to.fullPath }, // 保存原始路径，登录后可以跳转回来
      });
      return;
    }
  }

  next();
});

export default router;
